// extracted by mini-css-extract-plugin
export default {"SideNav-item":"SideNavV2-Item_SideNav-item__R9vsD","img":"SideNavV2-Item_img__umcf4","itemName":"SideNavV2-Item_itemName__7kfTi","active":"SideNavV2-Item_active__fkqcT"};